import "./PrimeFacesInplace";
import "./PrimeFacesTree";
import "./PrimeFacesSelectOneMenu";
import "./PrimeFacesFileUpload";

import "./PrimeFacesDragAndDrop";